import { isAfter } from 'date-fns';
import { User } from 'shared/types/user';
import { getUserLastSubscription } from 'shared/utils/get-user-last-subscription';

// once per expiry: a dismissal only counts until a later subscription has expired
export const getShouldShowRenewalNudge = (
  user: User | null | undefined,
  today: Date,
): boolean => {
  const lastSubscription = getUserLastSubscription(user);
  if (
    !lastSubscription?.expiresAt ||
    !isAfter(today, lastSubscription.expiresAt)
  ) {
    return false;
  }

  const closedDates = user?.user_metadata?.renewDialogClosed ?? [];
  const lastClosedDate = closedDates[closedDates.length - 1];
  return !lastClosedDate || isAfter(lastSubscription.expiresAt, lastClosedDate);
};
